import { render } from "./PronunciationEvaluator.vue?vue&type=template&id=463b7420&scoped=true"
import script from "./PronunciationEvaluator.vue?vue&type=script&lang=js"
export * from "./PronunciationEvaluator.vue?vue&type=script&lang=js"

import "./PronunciationEvaluator.vue?vue&type=style&index=0&id=463b7420&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463b7420"]])

export default __exports__